import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {AEM_DEVICE_SETTINGS_TYPES} from '@/consts/aem/aemDeviceSettingsTypes';
import {useSettingsContentWithoutLockUnlock} from '@/containers/DevicesPage/hooks/useSettingsContent';
import useDeviceSettingsEnabled from '@/hooks/useDeviceSettingsEnabled';
import {selectDeviceType} from '@/state/selectors/device';

const useDeviceSettingsContent = () => {
    const type = useSelector(selectDeviceType);
    const settingsContent = useSettingsContentWithoutLockUnlock();
    const {
        isAnySettingEnabled,
        isAemFlexBatteryEnabled,
        isPauseModeEnabled,
        isAutoStartEnabled,
        isFlexPuffEnabled,
        isSmartGesturesEnabled,
        isIlluminationModeEnabled,
        isVibrationEnabled,
        isLockEnabled,
    } = useDeviceSettingsEnabled({
        type,
    });

    const typeEnabledMap = {
        [AEM_DEVICE_SETTINGS_TYPES.FLEX_BATTERY]: isAemFlexBatteryEnabled,
        [AEM_DEVICE_SETTINGS_TYPES.PAUSE_MODE]: isPauseModeEnabled,
        [AEM_DEVICE_SETTINGS_TYPES.AUTO_START]: isAutoStartEnabled,
        [AEM_DEVICE_SETTINGS_TYPES.FLEX_PUFF]: isFlexPuffEnabled,
        [AEM_DEVICE_SETTINGS_TYPES.SMART_GESTURES]: isSmartGesturesEnabled,
        [AEM_DEVICE_SETTINGS_TYPES.ILLUMINATION_MODE]: isIlluminationModeEnabled,
        [AEM_DEVICE_SETTINGS_TYPES.VIBRATIONS]: isVibrationEnabled,
        [AEM_DEVICE_SETTINGS_TYPES.LOCK_UNLOCK]: isLockEnabled,
    };

    const filteredSettings = useMemo(
        () =>
            settingsContent
                .map((group) => {
                    const filteredItems = group.items.filter((item) => {
                        if (typeEnabledMap.hasOwnProperty(item.type)) {
                            return typeEnabledMap[item.type];
                        }
                        return true;
                    });

                    return filteredItems.length > 0 ? {...group, items: filteredItems} : null;
                })
                .filter(Boolean),
        [type]
    );

    return {isAnySettingEnabled, settings: filteredSettings};
};

export default useDeviceSettingsContent;
